import { currentBridgeData } from '@databases/database-state/state/bridge-data';
import { captureException } from '@sentry/core';

import { dispatchInitialDatabaseLoad } from '../dispatch-initial-database-load';

/**
 * When `contentReferenceId` is set, dispatches {@link dispatchInitialDatabaseLoad} with current
 * bridge fields. Errors are reported to Sentry and swallowed.
 */
export function tryDispatchDatabaseLoadFromCurrentBridge(): void {
  const { contentId, contentReferenceId, spaceId, spaceKey, spaceName, title } =
    currentBridgeData.data;

  if (!contentReferenceId) {
    return;
  }

  const payload = {
    contentId,
    contentReferenceId,
    spaceId,
    spaceKey,
    spaceName,
    title,
  };

  try {
    dispatchInitialDatabaseLoad(payload);
  } catch (error) {
    captureException(error);
  }
}
